
  



  // display benifits js start here 


  (function(window) {
    const testId = 'AB-09';
    const variantId = 'variant-1';
  
    waitFor(pageReady)
      .then(runVariant)
      .catch((err) => console.error(testId, err));
  
    function runVariant(atcForm) {
      atcForm.classList.add(`${testId}-restyled`);
      addIcons(atcForm);
      document.body.classList.add(testId);
      console.log(`${testId}: ${variantId}`);
    }
  
    function addIcons(form) {
      const icons = [
        {
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.834 1.33997C13.2482 1.33997 13.584 1.67575 13.584 2.08997V4.08997C13.584 4.50418 13.2482 4.83997 12.834 4.83997C12.4198 4.83997 12.084 4.50418 12.084 4.08997V2.08997C12.084 1.67575 12.4198 1.33997 12.834 1.33997ZM6.30365 5.55964C6.59655 5.26674 7.07142 5.26674 7.36431 5.55964L7.70758 5.9029C8.00047 6.19579 8.00047 6.67066 7.70758 6.96356C7.41468 7.25645 6.93981 7.25645 6.64692 6.96356L6.30365 6.6203C6.01076 6.3274 6.01076 5.85253 6.30365 5.55964ZM19.3643 5.55964C19.6572 5.85253 19.6572 6.3274 19.3643 6.6203L19.0211 6.96356C18.7282 7.25645 18.2533 7.25645 17.9604 6.96356C17.6675 6.67066 17.6675 6.19579 17.9604 5.9029L18.3037 5.55964C18.5965 5.26674 19.0714 5.26674 19.3643 5.55964ZM2.08398 12.09C2.08398 11.6758 2.41977 11.34 2.83398 11.34H4.83398C5.2482 11.34 5.58398 11.6758 5.58398 12.09C5.58398 12.5042 5.2482 12.84 4.83398 12.84H2.83398C2.41977 12.84 2.08398 12.5042 2.08398 12.09ZM20.084 12.09C20.084 11.6758 20.4198 11.34 20.834 11.34H22.834C23.2482 11.34 23.584 11.6758 23.584 12.09C23.584 12.5042 23.2482 12.84 22.834 12.84H20.834C20.4198 12.84 20.084 12.5042 20.084 12.09ZM7.70736 17.2166C8.00025 17.5095 8.00025 17.9844 7.70736 18.2773L7.36431 18.6203C7.07142 18.9132 6.59655 18.9132 6.30365 18.6203C6.01076 18.3274 6.01076 17.8525 6.30365 17.5596L6.6467 17.2166C6.93959 16.9237 7.41447 16.9237 7.70736 17.2166ZM17.9606 17.2166C18.2535 16.9237 18.7284 16.9237 19.0213 17.2166L19.3643 17.5596C19.6572 17.8525 19.6572 18.3274 19.3643 18.6203C19.0714 18.9132 18.5965 18.9132 18.3037 18.6203L17.9606 18.2773C17.6677 17.9844 17.6677 17.5095 17.9606 17.2166ZM12.834 19.34C13.2482 19.34 13.584 19.6758 13.584 20.09V22.09C13.584 22.5042 13.2482 22.84 12.834 22.84C12.4198 22.84 12.084 22.5042 12.084 22.09V20.09C12.084 19.6758 12.4198 19.34 12.834 19.34Z" fill="black"/><path d="M7.83398 11.1495C7.83398 13.6918 9.8437 15.0466 11.3149 16.2592C11.834 16.6871 12.334 17.09 12.834 17.09C13.334 17.09 13.834 16.6871 14.3531 16.2592C15.8243 15.0466 17.834 13.6918 17.834 11.1495C17.834 8.60714 15.0839 6.80417 12.834 9.24834C10.5841 6.80417 7.83398 8.60714 7.83398 11.1495Z" fill="black"/></svg>',
          copy: '<p>Unique &</p><p>Exclusive</p>'
        },
        {
          icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_533_4236)"><path d="M18.5003 4.09045C18.6509 4.09046 18.7995 4.12445 18.935 4.1899C19.0706 4.25535 19.1897 4.35057 19.2833 4.46845L19.3573 4.57645L22.3573 9.57645C22.4556 9.74041 22.5048 9.92908 22.4991 10.1201C22.4934 10.3112 22.4331 10.4966 22.3253 10.6545L22.2453 10.7575L13.7153 20.2905C13.5569 20.452 13.3679 20.5804 13.1592 20.668C12.9506 20.7555 12.7266 20.8006 12.5003 20.8005C12.1003 20.8005 11.7153 20.6605 11.3903 20.3835L11.2553 20.2575L2.75531 10.7575C2.62743 10.6148 2.54324 10.4384 2.51275 10.2492C2.48225 10.06 2.50675 9.86609 2.58331 9.69045L2.64331 9.57545L5.65631 4.55345L5.72031 4.46345C5.76608 4.40651 5.81807 4.35486 5.87531 4.30945L5.96431 4.24545L6.05231 4.19545L6.10231 4.17245L6.16231 4.14745L6.27131 4.11545L6.38331 4.09545L6.50031 4.09045H18.5003ZM9.61431 8.03345C9.38697 7.89732 9.1149 7.85697 8.85784 7.92128C8.60078 7.98559 8.37975 8.1493 8.24331 8.37645L7.64331 9.37645L7.58331 9.49245C7.50677 9.66894 7.48276 9.86375 7.51415 10.0535C7.54555 10.2433 7.63102 10.42 7.76031 10.5625L9.76031 12.7625L9.85031 12.8505C10.0354 13.0089 10.272 13.0942 10.5156 13.0905C10.7592 13.0869 10.9931 12.9944 11.1733 12.8305L11.2603 12.7405C11.4187 12.5553 11.5041 12.3188 11.5004 12.0752C11.4967 11.8316 11.4042 11.5977 11.2403 11.4175L9.73931 9.76745L9.95731 9.40445L10.0123 9.30145C10.1128 9.07804 10.1278 8.82551 10.0544 8.59177C9.98106 8.35804 9.82445 8.15937 9.61431 8.03345Z" fill="black"/></g><defs><filter id="filter0_d_533_4236" x="1.5" y="4.09045" width="22" height="18.71" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="1"/><feGaussianBlur stdDeviation="0.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_533_4236"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_533_4236" result="shape"/></filter></defs></svg>',
          copy: '<p>Long-Lasting</p><p>Durability</p>'
        },
        {
          icon: '<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.2482 7.98709C11.3248 6.05567 11.8631 5.08997 12.668 5.08997C13.4728 5.08997 14.0111 6.05567 15.0878 7.98708L15.3663 8.48676C15.6723 9.03561 15.8252 9.31003 16.0638 9.4911C16.3023 9.67217 16.5993 9.73938 17.1935 9.87381L17.7344 9.99619C19.8251 10.4692 20.8705 10.7058 21.1192 11.5055C21.3679 12.3053 20.6552 13.1387 19.2299 14.8054L18.8611 15.2366C18.4561 15.7102 18.2536 15.9471 18.1625 16.24C18.0714 16.533 18.102 16.849 18.1632 17.4809L18.219 18.0562C18.4345 20.28 18.5422 21.3919 17.8911 21.8862C17.24 22.3804 16.2612 21.9298 14.3036 21.0285L13.7972 20.7953C13.2409 20.5392 12.9628 20.4111 12.668 20.4111C12.3731 20.4111 12.095 20.5392 11.5387 20.7953L11.0323 21.0285C9.07474 21.9298 8.09597 22.3804 7.44484 21.8862C6.79372 21.3919 6.90147 20.28 7.11696 18.0562L7.17271 17.4809C7.23394 16.849 7.26456 16.533 7.17345 16.24C7.08235 15.9471 6.87983 15.7102 6.4748 15.2366L6.10605 14.8054C4.68073 13.1387 3.96807 12.3053 4.21678 11.5055C4.46548 10.7058 5.51085 10.4692 7.60157 9.99619L8.14247 9.87381C8.73659 9.73938 9.03365 9.67217 9.27217 9.4911C9.51069 9.31003 9.66367 9.03561 9.96962 8.48676L10.2482 7.98709Z" fill="black"/><path d="M5.03647 2.5903C5.06646 2.48452 5.25422 2.48388 5.28493 2.58946C5.42513 3.07157 5.6851 3.78419 6.07823 4.17467C6.47135 4.56515 7.18571 4.8203 7.66876 4.95724C7.77454 4.98723 7.77517 5.175 7.6696 5.2057C7.18749 5.34591 6.47487 5.60588 6.08439 5.999C5.69391 6.39213 5.43876 7.10649 5.30182 7.58953C5.27183 7.69532 5.08406 7.69595 5.05336 7.59037C4.91315 7.10826 4.65318 6.39565 4.26006 6.00517C3.86693 5.61469 3.15257 5.35954 2.66952 5.22259C2.56374 5.1926 2.56311 5.00484 2.66868 4.97413C3.1508 4.83393 3.86341 4.57396 4.25389 4.18083C4.64437 3.78771 4.89952 3.07335 5.03647 2.5903Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.168 3.33997C19.5822 3.33997 19.918 3.67575 19.918 4.08997V4.33997H20.168C20.5822 4.33997 20.918 4.67575 20.918 5.08997C20.918 5.50418 20.5822 5.83997 20.168 5.83997H19.918V6.08997C19.918 6.50418 19.5822 6.83997 19.168 6.83997C18.7538 6.83997 18.418 6.50418 18.418 6.08997V5.83997H18.168C17.7538 5.83997 17.418 5.50418 17.418 5.08997C17.418 4.67575 17.7538 4.33997 18.168 4.33997H18.418V4.08997C18.418 3.67575 18.7538 3.33997 19.168 3.33997Z" fill="black"/></svg>',
          copy: '<p>High</p><p>Quality</p>'
        }
      ];
      const html = `
      <div id="${testId}-icons">
        ${icons.map(icon => `
          <div class="${testId}-icon">
            ${icon.icon}
            <div class="${testId}-icon_copy">${icon.copy}</div>
          </div>`
    ).join('')}
      </div>`;
  
      form.insertAdjacentHTML('beforeend', html);
    }
  
    function pageReady() {
      return document.querySelector('form[id*="AddToCartForm"] button.add-to-cart') && document.querySelector('form[id*="AddToCartForm"] button.add-to-cart').closest('form');
    }
  
    function waitFor(condition, timeout) {
      const stopTime = typeof timeout === 'number' ? timeout : 7000;
      let stop = false;
  
      window.setTimeout(function() {
        stop = true;
      }, stopTime);
  
      // eslint-disable-next-line no-undef
      return new Promise(function(resolve, reject) {
        (function _innerWaitFor() {
          const value = condition();
  
          if (stop) {
            reject();
          } else if (value) {
            resolve(value);
          } else {
            window.setTimeout(_innerWaitFor, 50);
          }
        })();
      });
    }
  })(typeof unsafeWindow === 'undefined' ? window : unsafeWindow);
  // eslint-disable-next-line spaced-comment
  //# sourceURL=AB-09-variant-1.js


  // display benifits js end here 






// charms


$(document).on('click', '.new-add-to-cart-button', function(e){
e.preventDefault();
  $('.original-braclate-charm').show();
   $('body').css('overflow','hidden');
  });


$(document).on('click', '.close_popup_srction .hide_original-braclate', function(e){
    e.preventDefault();
    $('.original-braclate-charm').hide();
    $('body').css('overflow','auto');
   $('.charm_image img').show();
   $('#myCanvas').hide();
  $('.charm_popup').removeClass('shown');
  
  
});


////close////
$(document).on('click', '.close, .close2, .close3', function() {
    if ($(this).hasClass('close')) {
        $('.main_first_qnty_popup').hide();
    } else if ($(this).hasClass('close2')) {
        $('.main_second_qnty_popup').hide();
    } else if ($(this).hasClass('close3')) {
        $('.main_third_qnty_popup').hide();
    }
});

//closeend////











$(document).ready(function() {
 

    // Hide golden charms initially
    $('.Charms-Categories-main.golden_charm').css({
        'display': 'none',
        'opacity': '0'
    });

    // Show silver charms initially
    $('.Charms-Categories-main.silver_charm').css({
        'display': 'block',
        'opacity': '1'
    });

    // Event handlers for click events
    $(document).on('click', '.silver_charms', function() {
$('img.silver_charm_immmg').removeClass('hide');
$('.golden_charm_immmg').addClass('hide');
        $('.Charms-Categories-main.golden_charm').css({
            'opacity': '0',
            'display': 'none'
        });  
        $('.Charms-Categories-main.silver_charm').css({
            'display': 'block',
            'opacity': '1'
        });
        $('.silver_charms').css('border', '2px solid #932f48'); 
        $('.golden_charms').css('border', '2px solid #e6e6e6'); 
        $('.silver_charms span.silver_charms_content').css('color', '#932f48');
        $('.golden_charms span.golden_charms_content').css('color', '#1F1F1F'); 
    });

    $(document).on('click', '.golden_charms', function() {
$('img.silver_charm_immmg').addClass('hide');
$('.golden_charm_immmg').removeClass('hide');
        $('.Charms-Categories-main.silver_charm').css({
            'opacity': '0',
            'display': 'none'
        });  
        $('.Charms-Categories-main.golden_charm').css({
            'display': 'block',
            'opacity': '1'
        });
        $('.golden_charms').css('border', '2px solid #932f48'); 
        $('.silver_charms').css('border', '2px solid #e6e6e6'); 
        $('.silver_charms span.silver_charms_content').css('color', '#1F1F1F');
        $('.golden_charms span.golden_charms_content').css('color', '#932f48'); 
      
    });
});



$('.collection_products .product_image').each(function() {
        
        if ($(this).hasClass('show_after')) {
          
            $(this).css('border', 'none');
        }else{
            $(this).css('border', '2px solid #f2f2f2');
        }
    });


$(document).ready(function() {
    const canvas = document.getElementById("myCanvas");
    
    //aaaaqqqq
    if(!canvas) return false;

    const ctx = canvas.getContext("2d");
    let imageSources = [];
    const imageSize = 500;
    let images = [];
    let data_index_added = [];
    let removed_data_index = [];
    let globalIndexCounter = 1; // Global counter for data-index

    function loadImages(sources, callback) {
        let loadedImages = 0;
        const numImages = sources.length;

        sources.forEach((src, index) => {
            const img = new Image();
            img.src = src;
            img.onload = function() {
                images[index] = img;
                loadedImages++;
                if (loadedImages === numImages) {
                    callback();
                }
            };
            img.onerror = function() {
                console.error('Failed to load image:', src);
            };
        });
    }

    function drawImages() {
        ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear canvas before drawing
        const x = (canvas.width - imageSize) / 2;
        const y = (canvas.height - imageSize) / 2;

        images.forEach((img) => {
            ctx.drawImage(img, x, y, imageSize, imageSize); // Overlapping all images at the center
        });
    }

    $(document).on('click', '.product_main_collection .collection_title', function(e) {

        e.preventDefault();
 const quantityValue = $(this).find('.quantity_display_popup input#inpt_val').val();


      
 if(quantityValue == 0  && $(e.target).find('#stop_minus').length > 0){
            return;
}
    
 if(quantityValue == 1  && $(e.target).find('#stop_plus').length > 0){
 return; 
}

        const colActiveProducts = $(this).find('.collection_products');
        // Add the active class and update data-index
        colActiveProducts.addClass('active').each(function() {
            if (!$(this).attr('data-index')) {
                if (removed_data_index.length > 0) {
                    $(this).attr('data-index', removed_data_index.shift());

                } else {
                    $(this).attr('data-index', globalIndexCounter++);

                }
            }
        });

        const colActiveProductsHover = $(this).find('.collection_products.active .product_image');
        colActiveProductsHover.addClass('show_after');

        if (!$(this).hasClass('main_active')) {
            $(this).addClass('main_active');
 $(this).find('.quantity_display_popup input#inpt_val').val(1);
 $(this).closest('.collection_title').find('#stop_minus').attr('style', 'pointer-events: auto !important;');
 $(this).closest('.collection_title').find('#stop_plus').attr('style', 'pointer-events: none !important;');
        } else {
            // When removing the main_active class
            $(this).removeClass('main_active');
            $(this).find('.quantity_display_popup input#inpt_val').val(0);
$(this).closest('.collection_title').find('#stop_minus').attr('style', 'pointer-events: none !important;');
 $(this).closest('.collection_title').find('#stop_plus').attr('style', 'pointer-events: auto !important;');
            // Remove data-index and images associated with this collection
            colActiveProducts.each(function() {
                const dataIndex = $(this).attr('data-index');
                if (dataIndex) {
                    removed_data_index.push(parseInt(dataIndex)); // Add data-index to removed_data_index

                    // Find and remove the image associated with this data-index
                    $('.meta_product_imh .all_charm img.added').each(function() {
                        const imgSrc = $(this).attr('src');
                        const imgIndex = imageSources.indexOf(imgSrc);
                        if (imgIndex !== -1) {
                            imageSources.splice(imgIndex, 1);
                            images.splice(imgIndex, 1); // Remove the corresponding image from images array
                        }
                        // Remove 'added' class if it matches the data-index
                        const correspondingCharm = $(this).closest('.meta_product_imh .all_charm');
                        if (correspondingCharm.index() + 1 === parseInt(dataIndex)) {
                            $(this).removeClass('added');
                        }
                    });
                }
                $(this).removeAttr('data-index'); // Remove data-index
            });

            colActiveProducts.removeClass('active');
            colActiveProductsHover.removeClass('show_after');
            drawImages(); // Redraw canvas with remaining images
        }

        data_index_added = [];
        $('.collection_products.active').each(function() {
            const dataIndex = $(this).attr('data-index');
            if (dataIndex) {
                data_index_added.push(parseInt(dataIndex));
            }
        });
        // console.log('Data Index Added:', data_index_added);
        // console.log('Removed Data Index:', removed_data_index);

        const totalActiveProducts = $('.collection_products.active').length;
        updateProgressBar(totalActiveProducts);

        imageSources = []; // Reset the imageSources array
        images = []; // Reset the images array

        $('.collection_products.active').each(function() {
            const dataIndex = parseInt($(this).attr('data-index'));
            const charms = $(this).find('.meta_product_imh .all_charm');
            if (dataIndex > 0 && dataIndex <= charms.length) {
                charms.eq(dataIndex - 1).find('img').addClass('added');
            }
        });

        $('.meta_product_imh .all_charm img.added').each(function() {
            const imgSrc = $(this).attr('src');
            if (imgSrc) {
                imageSources.push(imgSrc);
            }
        });

        if (imageSources.length > 0) {
            loadImages(imageSources, drawImages);
        }
var qnt_yyy =  $(this).find('.quantity_display_popup input#inpt_val').val();
if(qnt_yyy==0){
 $(this).find('.quantity_display_popup').addClass('stoped');

}
var total_data = $('.qunatity_text .input_value_qty').text();
// alert('total_data' + total_data);
if(total_data == 0){
 globalIndexCounter = 1;
   data_index_added = [];
removed_data_index = [];
images = [];
images.length = 0;
imageSources = [];
// console.log('globalIndexCounteraaaaa', globalIndexCounter)
// console.log('data_index_addedaaaa', data_index_added);
// console.log('removed_data_indexaaaa', removed_data_index);
// console.log('imagesaaaa', images);
// console.log('imageSourcesaaaa', imageSources);



    var canvas = $('#myCanvas')[0];
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    $('.quantity_tecxt .qunatity').val(0);
    $('.collection_title').removeClass('main_active');
    $('.collection_title').removeClass('stop_click').css('pointer-events', 'auto');
    $('.collection_products.active').removeAttr('data-index').removeClass('active');
    $('.qunatity_text .input_value_qty').text(0);
    $('.processing_bar').css('width', '0%');
    $('.Collections-Selected-divs .Selected-div').removeClass('activeok');
 $('.Collections-Selected-divs .Selected-div').removeClass('activeOkk');
    $('.caharm-collection-para').text('0 of 3 Collections Selected');
    $('.Charms-Categories-main.golden_charm  .Collections-Selected-divs .Selected-div').removeClass('activeok');
    $('.product_image ').removeClass('show_after');

   
    $('.charm_popup').removeClass('shown');
$('.meta_product_imh .all_charm img').removeClass('added')
$('canvas#myCanvas').hide();
$('.charm_image img').show();
}else{
$('canvas#myCanvas').show();
$('.charm_image img').hide();
}

    });



    function updateProgressBar(totalActive) {
        const totalItems = 18;
console.log('totalActive',totalActive);
console.log('totalItems',totalItems);

if(totalActive == totalItems ){
$('.ADD-TO-CART.add_cart').removeClass('hide_data');

}else{

$('.ADD-TO-CART.add_cart').addClass('hide_data');

}


        let percentage = (totalActive / totalItems) * 100;

        if (totalActive >= totalItems) {
            percentage = 100;
        }
        $('.qunatity_text .input_value_qty').text(totalActive);
        $('.processing_bar').css('width', percentage + '%');
 
      
    }


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
$(document).on('click', '.silver_charms, .golden_charms', function(e){
e.preventDefault();

    // alert('hiii');
    globalIndexCounter = 1;
   data_index_added = [];
removed_data_index = [];
images = [];
images.length = 0;
imageSources = [];
// console.log('globalIndexCounterbbbb', globalIndexCounter)
// console.log('data_index_addedbbb', data_index_added);
// console.log('removed_data_indexbbb', removed_data_index);
// console.log('imagesbbb', images);
// console.log('imageSourcesbb', imageSources);



    var canvas = $('#myCanvas')[0];
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    $('.quantity_tecxt .qunatity').val(0);
    $('.collection_title').removeClass('main_active');
$('.collection_title').removeClass('stop_click').css('pointer-events', 'auto');
    $('.collection_products.active').removeAttr('data-index').removeClass('active');
    $('.qunatity_text .input_value_qty').text(0);
    $('.processing_bar').css('width', '0%');
    $('.Collections-Selected-divs .Selected-div').removeClass('activeok');
 $('.Collections-Selected-divs .Selected-div').removeClass('activeOkk');
    $('.caharm-collection-para').text('0 of 3 Collections Selected');
    $('.Charms-Categories-main.golden_charm  .Collections-Selected-divs .Selected-div').removeClass('activeok');
    $('.product_image ').removeClass('show_after');

   
    $('.charm_popup').removeClass('shown');
$('.meta_product_imh .all_charm img').removeClass('added')
$('.charm_image img').show();
$('canvas#myCanvas').hide();

});
///////////////////////////////////////////////////////////////////////////////////////////////////
$(document).on('click', '.close_popup_srction', function(e){
  // alert('hiii');
    globalIndexCounter = 1;
   data_index_added = [];
removed_data_index = [];
images = [];
images.length = 0;
imageSources = [];
// console.log('globalIndexCounterbbbb', globalIndexCounter)
// console.log('data_index_addedbbb', data_index_added);
// console.log('removed_data_indexbbb', removed_data_index);
// console.log('imagesbbb', images);
// console.log('imageSourcesbb', imageSources);



    var canvas = $('#myCanvas')[0];
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    $('.quantity_tecxt .qunatity').val(0);
    $('.collection_title').removeClass('main_active');
$('.collection_title').removeClass('stop_click').css('pointer-events', 'auto');
    $('.collection_products.active').removeAttr('data-index').removeClass('active');
    $('.qunatity_text .input_value_qty').text(0);
    $('.processing_bar').css('width', '0%');
    $('.Collections-Selected-divs .Selected-div').removeClass('activeok');
 $('.Collections-Selected-divs .Selected-div').removeClass('activeOkk');
    $('.caharm-collection-para').text('0 of 3 Collections Selected');
    $('.Charms-Categories-main.golden_charm  .Collections-Selected-divs .Selected-div').removeClass('activeok');
    $('.product_image ').removeClass('show_after');

   
    $('.charm_popup').removeClass('shown');
$('.meta_product_imh .all_charm img').removeClass('added')
});

});





 $(document).ready(function() {
    var activePopupIndex = -1;
    var isFirstMainActive = false; 

    $(document).on('click', '.collection_title:not(.disabled)', function() {
        var activeCount = $('.collection_title.main_active').length;

if (activeCount > 3) {
            activeCount = 3;
        }
        $('.caharm-collection-para').text(activeCount + ' of 3 Collections Selected');

        $('.Collections-Selected-divs .Selected-div').each(function(index) {
            if (index < activeCount) {
                $(this).addClass('activeok');
            } else {
                $(this).removeClass('activeok');
            }
        });

        if (activeCount === 3) {
            $('.collection_title').not('.main_active').addClass('stop_click').css('pointer-events', 'none');
        }else{
$('.collection_title').not('.main_active').removeClass('stop_click').css('pointer-events', 'auto');
}
    });


});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////
$(document).on('click', '#stop_plus', function(e) {
    e.preventDefault();
    
    // Get the value of the .qunatity input field
     var pppp =  $(this).closest('.collection_title').find('.quantity_tecxt .qunatity').val();
    // alert('pppp: ' + pppp);
    
    $(this).addClass('stop_cliiii').css('pointer-events', 'none');
    
    // Enable the #stop_minus button
    $(this).closest('.collection_title').find('#stop_minus').removeClass('stop_work').css('pointer-events', 'auto');
});






$(document).ready(function() {
    var activePopupIndex = -1;
    var isFirstMainActive = false;

    $(document).on('click', '.Charms-Categories-main.golden_charm .collection_title', function(e) {
        e.preventDefault();
        
        // Count the number of active collection titles
        var activeCount = $('.Charms-Categories-main.golden_charm .collection_title.main_active').length;
        
        // Update text based on the active count
        $('.caharm-collection-para').text(activeCount + ' of 3 Collections Selected');

        // Apply 'activeOkk' class to the selected divs based on the active count
        $('.Charms-Categories-main.golden_charm .Collections-Selected-divs .Selected-div').each(function(index) {
            if (index < activeCount) {
                $(this).addClass('activeOkk');
            } else {
                $(this).removeClass('activeOkk');
            }
        });

        // Disable or enable the collection titles based on the active count
        if (activeCount === 3) {
            $('.Charms-Categories-main.golden_charm .collection_title').not('.main_active').addClass('stop_click').css('pointer-events', 'none');
$('#stop_plus').addClass('stop_click').css('pointer-events', 'none');
        } else {
            $('.Charms-Categories-main.golden_charm .collection_title').not('.main_active').removeClass('stop_click').css('pointer-events', 'auto');
$('#stop_plus').removeClass('stop_click').css('pointer-events', 'auto');
        }
    });
});
//////////////////////////////////////////////////////////////
$(document).on('click', '.charms_all', function(e) {
    e.preventDefault();
    
    $('.charms_all').removeClass('charm_active');
    
    $(this).addClass('charm_active');
});


////////////////////////////////////////////////////////////////////////
$(document).on('click', '.add_cart', function(e) {
    var properties = [];
    var productCounter = 1; 
    var collectioncounter = 1;
    var charm_active = $('.charm_active').attr('data_of_charms');
    // alert('charm_active: ' + charm_active);
    // var canvas = document.getElementById('myCanvas');
    // var canvasImageUrl = canvas.toDataURL('image/png');
    // console.log('canvasImageUrl', canvasImageUrl);

    
    // properties.push({ key: 'Selected Charm', value: charm_active });
    // properties.push({ key: 'Final Image URL', value: canvasImageUrl });
      $('.add_to_cart_btn').hide();
       $('.loader_gifff').show();
    $('.collection_title.main_active').each(function(collectionIndex) {
        var col_name = $(this).find('.collection_title_new p').attr('col_nam');
        // alert('col_name: ' + col_name);
        // properties.push({ key: 'Collection ' + collectioncounter + ' Name', value: col_name });

        $(this).find('.collection_products.active').each(function(productIndex) {
            var product_title = $(this).find('.product_title').html();  
            var product_id = $(this).attr('product_id');
            var image = $(this).find('.all_charm img.added').closest('.all_charm').attr('img_data');
            // properties.push({ key: 'Product ' + productCounter, value: product_title + ',' + product_id + ',' + image });

            productCounter++; 
        });
        collectioncounter++;
    });

    console.log(properties);

    var dddddd = {};
    properties.forEach(function(item) {
        dddddd[item.key] = item.value;
    });

    console.log(dddddd);

    var main_product = $('.original_braclate_heading').attr('variant_id_main');

///////////////////////// 




// ///////////////////////////////////////////////////////////////////////////////////////
   let imageSrcs = $('.collection_products.active .product_image img').map(function() {
        return $(this).attr('src');
    }).get();

  
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const loadImage = (src) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous'; 
            img.src = src;
            img.onload = () => resolve(img); 
            img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
        });
    };


    const drawRoundedRect = (ctx, x, y, width, height, radius) => {
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
    };

    Promise.all(imageSrcs.map(src => loadImage(src))).then(images => {
        const fixedHeight = 115; 
        const spacing = 15; 
        const imagesPerRow = 4; 
        const textPadding = 40; 
        const totalPadding = 15; 

       
        let totalRowWidth = 0;
        images.slice(0, imagesPerRow).forEach(img => {
            const aspectRatio = img.width / img.height;
            totalRowWidth += (fixedHeight * aspectRatio) + spacing;
        });
        totalRowWidth -= spacing; 
        totalRowWidth += totalPadding * 2; 

      
        canvas.width = totalRowWidth;
        const totalHeight = Math.ceil(images.length / imagesPerRow) * (fixedHeight + spacing + textPadding); 
        canvas.height = totalHeight;

        images.forEach((img, index) => {
            const aspectRatio = img.width / img.height;
            const width = fixedHeight * aspectRatio; 
            const xPosition = (index % imagesPerRow) * (width + spacing) + totalPadding; 
            const yPosition = Math.floor(index / imagesPerRow) * (fixedHeight + spacing + textPadding) + textPadding + 5; 
            const borderRadius = 10; 
            const borderColor = '#932F49';
            const borderWidth = 5;
            ctx.save();

            
            drawRoundedRect(ctx, xPosition, yPosition, width, fixedHeight, borderRadius);

            
            ctx.lineWidth = borderWidth;
            ctx.strokeStyle = borderColor;
            ctx.stroke(); 

           
            ctx.clip(); 
            ctx.drawImage(img, xPosition, yPosition, width, fixedHeight);
            ctx.restore();

            ctx.font = '20px Arial';
            ctx.fillStyle = 'black';
            ctx.textAlign = 'center'; 
            ctx.textBaseline = 'bottom'; 
            const textXPosition = xPosition + width / 2; 
            const textYPosition = yPosition - 10; 

            ctx.fillText(index + 1, textXPosition, textYPosition); 
        });

     
        const base64Image = canvas.toDataURL('image/png');
        console.log("Generated Base64 Image:", base64Image);
        
var new_data = '';


var data = {
    base64Data: base64Image 
};

$.ajax({
    type: "POST",
    url: "/apps/fabulove",
    contentType: "application/json",
    data: JSON.stringify(data), 
    success: function(result) {
        console.log(result);
    },
    error: function(xhr, status, error) {
        console.error('Error:', error);
    }
});
    }).catch(error => {
        console.error('Error loading images:', error);
    });
// /////////////////////////////////////////////////////////////

var data = {
        id: main_product,
        quantity: 1,
        properties: dddddd
    };


   $.ajax({
        type: "GET",
        url: "/apps/fabulove",
        success: function(result) {
            console.log(result);
            var urlImage = result.urlImageOutput;
            // console.log(urlImage);
            data.properties.CharmsImage = urlImage; 
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                success: function(response) {
                $('.add_to_cart_btn').show();
                  $('.loader_gifff').hide();
                    console.log(response);
                    window.location.href = '/cart'; 
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error("Error adding to cart: ", textStatus, errorThrown);
                }
            });
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.error("AJAX error: ", textStatus, errorThrown);
        }
    });



// /////////////////////////////

    // var data = {
    //     id: main_product,
    //     quantity: 1,
    //     properties: dddddd
    // };



// $.ajax({
//     type: "POST",
//     url: "/apps/fabulove",
//     data:data,
//     success: function(result){
//         console.log(result);


      
    // $.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js', 
    //     data: data,
    //     success: function(response) {
    //         console.log(response);
    //          window.location.href = '/cart';
    //     }
    // });


      

//       }
// });

  
  
});

/////////////////////////////////////////////////////////////////////////////////////////
$(document).on('click', '.hide_plus_popup', function(){
$('.plus_popup_main').hide();

})
$(document).on('click', '.after-element', function(e){
    e.stopPropagation();
    $('.plus_popup_main').show();
    var ppp = $(this).closest('.product_image').find('img').attr('src');
    $('.plus_popup_img img').attr('src', ppp);
    var show_img_popup = $('.plus_popup_img img').attr('src');
    
});



// countdown timer js start here 


// $(document).ready(function () {
//     function startCountdown() {
//         const timerElement = $(".countdown-timer");
//         const COOKIE_NAME = "countdown-timer-end";
//         const countdownDuration = (22 * 60 * 60 + 55 * 60 + 50) * 1000; // Convert 22:55:50 to milliseconds
//         // const countdownDuration = (0 * 60 * 60 + 0 * 60 + 50) * 1000; // Convert 22:55:50 to milliseconds

//         function getCookie(name) {
//             const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
//                 const [key, value] = cookie.split("=");
//                 acc[key] = decodeURIComponent(value);
//                 return acc;
//             }, {});
//             return cookies[name];
//         }

//         function setCookie(name, value, days) {
//             const expires = new Date();
//             expires.setTime(expires.getTime() + days * 5000 * 60 * 60 * 1000);
//             document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
//         }

//         // Retrieve or set the end time
//         let endDate;
//         const existingEndTime = getCookie(COOKIE_NAME);

//         if (existingEndTime) {
//             endDate = new Date(parseInt(existingEndTime, 10));
//         } else {
//             endDate = new Date();
//             endDate.setTime(endDate.getTime() + countdownDuration); // Add 22:55:50
//             setCookie(COOKIE_NAME, endDate.getTime(), 1); // Store end time in cookie
//         }

//         function updateCountdown() {
//             const now = new Date().getTime();
//             const timeLeft = endDate.getTime() - now;

//             if (timeLeft <= 0) {
//                 clearInterval(countdownInterval);
//                 timerElement.find(".hours").text("00");
//                 timerElement.find(".minutes").text("00");
//                 timerElement.find(".seconds").text("00");
//                 console.log("Countdown finished.");
//                 return;
//             }

//             const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//             const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
//             const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

//             timerElement.find(".hours").text(hours.toString().padStart(2, "0"));
//             timerElement.find(".minutes").text(minutes.toString().padStart(2, "0"));
//             timerElement.find(".seconds").text(seconds.toString().padStart(2, "0"));
//         }

//         const countdownInterval = setInterval(updateCountdown, 1000);
//         updateCountdown(); // Initial call
//     }

//     startCountdown();
// });



$(document).ready(function () {
    function startCountdown() {
        const timerElement = $(".countdown-timer");
        const COOKIE_NAME = "countdown-timer-end";
        const FINISHED_COOKIE_NAME = "countdown-finished";
        const countdownDuration = (22 * 60 * 60 + 55 * 60 + 50) * 1000; // Convert 22:55:50 to milliseconds
  
        function getCookie(name) {
            const cookies = document.cookie.split("; ");
            for (let cookie of cookies) {
                const [key, value] = cookie.split("=");
                if (key === name) {
                    return decodeURIComponent(value);
                }
            }
            return null; // Return null if the cookie does not exist
        }
  
        function setCookie(name, value, days) {
            let expires = "";
            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Set expiration date
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
        }
  
        // Check if countdown has already finished and avoid starting it if it has
        const countdownFinished = getCookie(FINISHED_COOKIE_NAME);
        if (countdownFinished) {
            console.log("Countdown has already finished within the last year.");
            return;
        }
  
        // Retrieve or set the end time
        let endDate;
        const existingEndTime = getCookie(COOKIE_NAME);
        if (existingEndTime) {
            endDate = new Date(parseInt(existingEndTime, 10));
        } else {
            endDate = new Date();
            endDate.setTime(endDate.getTime() + countdownDuration); // Add 22:55:50
            setCookie(COOKIE_NAME, endDate.getTime(), 365); // Store end time in cookie for 1 year
        }
  
        function updateCountdown() {
            const now = new Date().getTime();
            const timeLeft = endDate.getTime() - now;
  
            if (timeLeft <= 0) {
                clearInterval(countdownInterval);
                timerElement.find(".hours").text("00");
                timerElement.find(".minutes").text("00");
                timerElement.find(".seconds").text("00");
                console.log("Countdown finished.");
  
                // Set the finished cookie for 1 year
                setCookie(FINISHED_COOKIE_NAME, "true", 365);
                return;
            }
  
            const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
  
            timerElement.find(".hours").text(hours.toString().padStart(2, "0"));
            timerElement.find(".minutes").text(minutes.toString().padStart(2, "0"));
            timerElement.find(".seconds").text(seconds.toString().padStart(2, "0"));
        }
  
        const countdownInterval = setInterval(updateCountdown, 1000);
        updateCountdown(); // Initial call
    }
  
    startCountdown();
  });
  


// countdown timer js end here 